<nb-card class="card-box">
    <nb-card-header class="content-header">
        <nb-icon class="icon" icon="folder-add-outline" status="basic"></nb-icon>
        <span class="title">{{'device.files.new-catalog' | translate}}</span>
        <nb-icon class="close" icon="close-outline" (click)="cancel()"></nb-icon>
    </nb-card-header>
    
    <nb-card-body class="content-body">
        <form [formGroup]="formGroup" class="form-group">
            <div class="row">
                <div class="col-12">
                    <label for="folderName">{{'device.files.enter-catalog-name' | translate}}</label>
                    <input
                    nbInput
                    required
                    fullWidth
                    class="form-control"
                    id="folderName"
                    name="folderName"
                    formControlName="folderName"
                    [fieldSize]="'large'"
                    [status]="hasError('folderName') ? 'danger' : 'primary'"
                    />
                </div>
                
                <app-control-messages
                [control]="getFormControl('folderName')"
                ></app-control-messages>
            </div>
        </form>
    </nb-card-body>
    
    <nb-card-footer class="content-footer">
        <button
            nbButton
            tabindex="-1"
            [size]="'large'"
            [status]="'control'"
            [appearance]="'outline'"
            (click)="cancel()">
        {{ "common.cancel" | translate }}
    </button>
    
    <button
        nbButton
        tabindex="-1"
        size="large"
        status="primary"
        nbSpinnerStatus="info"
        [nbSpinner]="loading"
        [disabled]="loading || formGroup.invalid"
        (click)="createNewFolder()">
    {{ "common.add" | translate }}
</button>
</nb-card-footer>
</nb-card>
